import {PollHistoryComponent} from './pages/ipl/live-matches/poll-history/poll-history.component';
import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {LoginComponent} from './pages/login/login.component';
import {HomeComponent} from './pages/home/home.component';
import {ProductComponent} from './pages/product/product.component';
import {ExperiencesComponent} from './pages/experiences/experiences.component';
import {PagenotfoundComponent} from './pages/pagenotfound/pagenotfound.component';
import {TncComponent} from './pages/tnc/tnc.component';
import {PpComponent} from './pages/pp/pp.component';
import {ContactUsComponent} from './pages/contact-us/contact-us.component';
import {AboutComponent} from './pages/about/about.component';
import {FaqsComponent} from './pages/faqs/faqs.component';
import {ProductEnquiryComponent} from './pages/product-enquiry/product-enquiry.component';
import {MyaccountComponent} from './pages/myaccount/myaccount.component';
import {OrdersComponent} from './pages/myaccount/orders/orders.component';
import {PaymentsComponent} from './pages/myaccount/payments/payments.component';
import {ProfileComponent} from './pages/myaccount/profile/profile.component';
import {BucketComponent} from './pages/myaccount/bucket/bucket.component';
import {OrderSummaryComponent} from './pages/order-summary/order-summary.component';
import {StandardComponent} from './pages/home/standard/standard.component';
import {StandardExperiencesComponent} from './pages/listing/standard-experiences/standard-experiences.component';
import {ComingSoonComponent} from './pages/coming-soon/coming-soon.component';
import {SearchComponent} from './pages/search/search.component';
import {SearchExclusiveComponent} from './pages/search-exclusive/search-exclusive.component';
import {CanDeactivateGuard} from './services/can-deactivate.guard';
import {LocationComponent} from './pages/location/location.component';
//IPL
import {LiveMatchesComponent} from './pages/ipl/live-matches/live-matches.component';
import {LandingPageComponent} from './pages/ipl/live-matches/landing-page/landing-page.component';
import {MyCouponsComponent} from './pages/ipl/live-matches/my-coupons/my-coupons.component';
import {CorporateBookingComponent } from './pages/corporate-booking/corporate-booking.component';
import { ReschedulePageComponent } from './pages/reschedule-page/reschedule-page.component';
import { OrderConfirmationStatusComponent } from './pages/order-confirmation-status/order-confirmation-status.component';

const routes: Routes = [

  // home
  {path: '', redirectTo: '/mumbai/exclusives', pathMatch: 'full'},

  // static pages
  {path: 'terms-and-conditions', component: TncComponent},
  {path: 'privacy-policy', component: PpComponent},
  {path: 'contact-us', component: ContactUsComponent},
  {path: 'about-us', component: AboutComponent},
  {path: 'faqs', component: FaqsComponent},


  // IPL
  {path: ':city/play-deal-pe-deal/play', component: LiveMatchesComponent},
  {path: ':city/play-deal-pe-deal', component: LandingPageComponent},
  {path: 'my-coupons', component: MyCouponsComponent},
  {path: 'my-poll-histroy', component: PollHistoryComponent},

  // exclusive
  {path: ':city/exclusives', component: HomeComponent}, // home page
  {path: ':city/exclusives/:category', component: HomeComponent},
  {path: ':city/exclusives/search/:keyword', component: SearchExclusiveComponent},
  {path: ':city/:slug/enquiry/:id', component: ProductEnquiryComponent},

  // deals
  {path: ':city/deals', component: StandardComponent}, // deals homepage
  {path: ':city/deals/:category', component: StandardExperiencesComponent},
  {path: ':city/deals/by/:merchant', component: StandardExperiencesComponent},
  {path: ':city/deals/search/:keyword', component: SearchComponent},


  // product
  {path: ':city/:slug', component: ProductComponent},

  // orders
  {path: 'order-summary', component: OrderSummaryComponent, canDeactivate: [CanDeactivateGuard]},

  // my account secton
  {path: 'my-account', component: MyaccountComponent},
  {path: 'my-account/orders', component: OrdersComponent},
  {path: 'my-account/payments', component: PaymentsComponent},
  {path: 'my-account/profile', component: ProfileComponent},
  {path: 'my-account/bucket-list', component: BucketComponent},

  //18-july-2022
  {path: 'corporate-booking', component: CorporateBookingComponent},

  // others
  { path: 'error', component: PagenotfoundComponent, pathMatch: 'full' },
  
  //17 Aug 2022
  {path: 'reschedule-time', component: ReschedulePageComponent },
  {path:'order-confirmation-status',component:OrderConfirmationStatusComponent},


  // {path: 'c/:city/standard/experiences', component: StandardExperiencesComponent, pathMatch: 'full'},
  // {path: 'c/:city/m/:merchant/standard/experiences', component: StandardExperiencesComponent, pathMatch: 'full'},
  // listing


  // unused
  {path: '**', component: PagenotfoundComponent, pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    initialNavigation: 'enabled',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
